<template>
    <app-content-admin>
        <template slot="header">View AdPlacement Details</template>
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="secondary"
                to="/adplacement"
            >
                Back
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Placement Name')"
                                        v-model="form.placement_name"
                                        :rules="[
                                            rules.required('Placement Name'),
                                        ]"
                                        :data-label="$t('Placement Name')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Placement Description')"
                                        v-model="form.placement_description"
                                        :rules="[
                                            rules.required(
                                                'Placement Description'
                                            ),
                                        ]"
                                        :data-label="
                                            $t('Placement Description')
                                        "
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Rotate Max(Seconds)')"
                                        v-model="form.placement_rotate_max"
                                        :data-label="$t('Rotate Max(Seconds)')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="handlePlacementRotateTimeInput"
                                        :rules="[
                                            rules.required(
                                                'Rotate Max(Seconds)'
                                            ),
                                        ]"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-switch
                                        :label="$t('Placement Active')"
                                        v-model="form.placement_active"
                                        :data-label="$t('Placement Active')"
                                        outlined
                                    ></v-switch>
                                </v-flex>
 
                         
                                <v-select
                                    v-model="form.selectedZoneNames"
                                    :items="GetZoneData"
                                    item-text="zone_name"
                                    item-value="zone_name"
                                    label="Select"
                                    multiple
                                    return-object
                                    clearable
                                    placeholder="Select Zone Names"
                                    persistent-hin
                                    @input="updateSelectedZones"
                                    :rules="[
                                        (v) =>
                                            (!!v && v.length > 0) ||
                                            'Please select at least one Zone Name',
                                    
                                    ]"
                               
                           
                                />


                                
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="updateAdPlacement"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";
import router from "../../router";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                placement_id: null,
                placement_name: null,
                placement_description: null,
                placement_rotate_max: 0,
                placement_active: 0,
                token: null,
                relatedZoneNames: [],
                zone_names: [], // Initialize zone_names as an empty array
                // Initialize selectedZoneIds as an empty array
                selectedZoneNames: [],
               
            },
            
            GetZoneData: [],
        };
    },
    

    components: { ActiveLabel },

    created() {
        this.form.placement_id = this.$route.params.id;
        //Load complete specific placement data and  all zone data
        this.getAdPlacement();
        this.zoneListData();


        
    },

    methods: {
        //Update specific Placement data
        async updateAdPlacement() {
            let loader = this.$loading.show();
            try {

              
              this.form.zone_names = this.form.selectedZoneNames
              
               console.log("Latest update",this.form)
           
                let res = await axios.post(
                    `/api/auth/update_placement`,
                    this.form
                );
                console.log("Update data", res);
                if (res.status == 200) {
                    this.$toastr.s("AdPlacement update successfully");
                    router.push("/adplacement");
                }
            } catch (err) {
                if (err.response.status == 400) {
                    // Validation errors returned by the server
                    console.log("Update Placement Error", err.response);
                   // this.$toastr.e("Please input all required data");
                } else {
                   // this.$toastr.e("An error occurred while creating the AdPlacement.");
                    console.log("Error create adPlacement", err);
                }
            } finally {
                loader.hide();
            }
        },

        //Read specific placement data
        async getAdPlacement() {
            let loader = this.$loading.show();
            try {
                let res = await axios.get(`/api/auth/get_placement`, {
                    params: { placement_id: this.form.placement_id },
                });

                if (res.status == 200) {
                    const adPlacement = res.data.placement;
                
                    this.form.placement_name = adPlacement.placement_name;
                    this.form.placement_description =adPlacement.placement_description;
                    this.form.placement_rotate_max =adPlacement.placement_rotate_max;
                    this.form.placement_active = adPlacement.placement_active;



                    // Extract zone names from the API response and store them in this.form.relatedZoneNames
                    this.form.selectedZoneNames = res.data.zones.map((zone) => zone.zone_name);

                    

                    console.log("Placement Data:",adPlacement);
                   console.log("Zone Names:", this.form.selectedZoneNames);

                
                }
            } catch (err) {
                //this.$toastr.e(err.response.data.message);
                console.log("Get specific adzone data fail");
            } finally {
                loader.hide();
            }
        },

        //Auto correct zero or negative typing to postive num typing placment rotate time
        handlePlacementRotateTimeInput() {
            // Ensure that the value is not negative
            if (this.form.placement_rotate_max < 0) {
                this.form.placement_rotate_max = 0;
            }

            // Remove leading zeros
            if (
                this.form.placement_rotate_max.length > 1 &&
                this.form.placement_rotate_max[0] === "0"
            ) {
                this.form.placement_rotate_max =
                    this.form.placement_rotate_max.slice(1);
            }
        },

        //Read All Adzone Data
        zoneListData() {
            let loader = this.$loading.show();

            axios
                .get(`/api/auth/get_ad_zone_list`)
                .then((res) => res.data)
                .then((res) => {
                   // this.GetZoneData = res.data.result;
                    this.GetZoneData = res.data.result.map(zone => zone.zone_name);

                    console.log("Final adlist Zone IDs:", this.GetZoneData);
                })

                .catch((e) => {
                  //  this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },

 

        
updateSelectedZones(selectedZoneNames) {
     
           // Update the selected zone names array
          this.form.selectedZoneNames = selectedZoneNames.map(zone => zone.zone_name);


     // Check if selectedZoneNames is an array of objects or an array of strings
    if (Array.isArray(selectedZoneNames) && selectedZoneNames.length > 0 && typeof selectedZoneNames[0] === 'object') {
        // Map selectedZoneNames to zone_name if it's an array of objects
        this.form.selectedZoneNames = selectedZoneNames.map(zone => zone.zone_name);
    } else {
        // Keep selectedZoneNames as it is if it's an array of strings
        this.form.selectedZoneNames = selectedZoneNames;
    }

    console.log("Latest current zone name:",this.form.selectedZoneNames)

}
        
      
    },
};
</script>
<style>
.theme--light.v-text-field--outlined:not(
        .v-input--is-focused
    ).v-input--is-disabled
    > .v-input__control
    > .v-input__slot
    fieldset {
    color: rgba(0, 0, 0, 0.36);
}

.theme--light.v-label--is-disabled {
    color: rgba(0, 0, 0, 0.6);
}

.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 0.6);
}

.theme--light.v-select .v-select__selection--disabled {
    color: rgba(0, 0, 0, 0.6);
}
</style>
